import { FeatureSwitches } from '../../constants/feature-switches';
import { getDateObject } from '../order-history/card-utils';
// THIS FILE WAS CREATED BECAUSE HAVING FeatureSwitches IN THE SAME FILE AS ANOTHER UTIL FN MADE IT SO ANY WHO IMPORTED THE FILE ITSELF
// NEEDED TO MOCK THE FEATURE SWITCH FILE AS WELL. THIS FILE IS A WORKAROUND TO THAT ISSUE
/**
 * Util function to help determine if a return is a return done before the CXO migration. Helpful for determining if barcode should be shown due to legacy returns not having one
 * EDGE CASE: if return date or CXO config value is undefined then we should still show the barcode button as a fallback
 *  */
export var isLegacyUPSReturn = function (returnsInitiatedDate) {
    var returnsInitiatedDateObj = getDateObject(returnsInitiatedDate);
    var cxoDeploymentDateString = typeof FeatureSwitches.CXO_UPS_DEPLOYMENT_DATE === 'string'
        ? FeatureSwitches.CXO_UPS_DEPLOYMENT_DATE
        : '';
    var cxoDeploymentDateObj = getDateObject(cxoDeploymentDateString);
    return Boolean(returnsInitiatedDateObj &&
        cxoDeploymentDateObj &&
        returnsInitiatedDateObj < cxoDeploymentDateObj);
};
